import type { Params, Hierarchy, CurveMode } from '../../lib/types';
import { Select, Slider } from './widgets';

export function VTracerGroup({ params, setParam }: { params: Params; setParam: <K extends keyof Params>(k: K, v: Params[K]) => void }) {
  return (
    <>
      <Select<Hierarchy> label="Hierarchy" value={params.hierarchy} options={[['stacked', 'stacked'], ['cutout', 'cutout']]} onChange={(v) => setParam('hierarchy', v)} />
      <Select<CurveMode> label="Curve mode" value={params.curveMode} options={[['pixel', 'pixel'], ['polygon', 'polygon'], ['spline', 'spline']]} onChange={(v) => setParam('curveMode', v)} />
      <Slider label="Layer difference" min={0} max={256} step={1} value={params.layerDifference} onChange={(v) => setParam('layerDifference', v)} />
      <Slider label="Corner angle (°)" min={0} max={180} step={1} value={params.cornerAngle} onChange={(v) => setParam('cornerAngle', v)} />
      <Slider label="Min path length" min={3.5} max={10} step={0.1} value={params.minPathLength} onChange={(v) => setParam('minPathLength', v)} />
      <Slider label="Splice angle (°)" min={0} max={180} step={1} value={params.spliceAngle} onChange={(v) => setParam('spliceAngle', v)} />
      <Slider label="Path precision" min={1} max={8} step={1} value={params.pathPrecision} onChange={(v) => setParam('pathPrecision', v)} />
      <Slider label="Max iterations" min={1} max={20} step={1} value={params.maxIterations} onChange={(v) => setParam('maxIterations', v)} />
    </>
  );
}
